import clsx from "clsx";
import { CompareChip } from "../@types";
import { CompareSide } from "./@types";
import { uniqueGlyph } from "./utils";
import styles from "./compare-samples.module.scss";

interface ChipsProps {
  chips: CompareChip[];
  side: CompareSide;
}

const Chips = ({ chips, side }: ChipsProps): JSX.Element => {
  if (!chips.length) {
    return <span className={styles.empty}>None</span>;
  }

  return (
    <div className={styles.chips}>
      {chips.map(chip => (
        <span
          key={chip.text}
          className={clsx(styles.chip, {
            [styles["chip--unique"]]: !chip.shared
          })}
        >
          {!chip.shared && (
            <span className={styles["chip-glyph"]}>{uniqueGlyph(side)}</span>
          )}
          {chip.text}
        </span>
      ))}
    </div>
  );
};

export default Chips;
